import { PHOTOS } from "@/lib/brand";

export default function PhotoSlider() {
  const row = [...PHOTOS, ...PHOTOS];
  return (
    <section className="bg-brand-black border-y border-white/10 py-16 overflow-hidden" data-testid="photo-slider">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 mb-8">
        <div className="text-brand-gold text-xs font-bold tracking-[0.3em] uppercase mb-3">Life at the Club</div>
        <h2 className="font-display text-5xl sm:text-6xl text-white flex items-center gap-4">
          <span className="w-12 h-1 bg-brand-red inline-block" />IN ACTION
        </h2>
      </div>
      <div className="relative w-full overflow-hidden">
        <div className="flex gap-4 w-max animate-marquee hover:[animation-play-state:paused]">
          {row.map((src, i) => (
            <div key={`${src}-${i}`} className="h-56 sm:h-72 shrink-0 overflow-hidden border border-white/10">
              <img src={src} alt="Lansdowne youth rugby" loading="lazy" className="h-full w-auto object-cover" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
